/* src/app/global/layouts/layout-main/layout-main.component.scss */
:host,
:host > .cw-flex-row {
  height: 100%;
}
/*# sourceMappingURL=layout-main.component.css.map */
